module.exports = __webpack_public_path__ + "img/jacket2.67e9baea.svg";